import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../../environments/environment';
import { DatePipe } from "@angular/common"
import { Surveyentry } from "./surveyentry.model";
import { Customer } from "../../../customer/shared/customer.model";

@Injectable({
  providedIn: 'root'
})

export class SurveyentryService {
  selectedSurveyentry: Surveyentry;
  selectedSurveyentryList: Surveyentry[];
  surveyCustomersList: Customer[];

  constructor(private httpClient: HttpClient, private datePipe: DatePipe) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDSurveyEntry(surveyentry: any) {

    surveyentry.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    surveyentry.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    surveyentry.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    surveyentry.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = surveyentry;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SurveyEntry/IUD', body, { headers: headers });
  
  }

  FetchSurveyEntryList() {
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SurveyEntry/FetchList', body, { headers: headers });
  }

  FetchSurveyEntryById(SurveyNo : any) {

    this.selectedSurveyentry = new  Surveyentry();
    this.selectedSurveyentry.Id = 0;
    this.selectedSurveyentry.SurveyNo = + SurveyNo;
    this.selectedSurveyentry.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSurveyentry.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSurveyentry.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSurveyentry.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body =  this.selectedSurveyentry;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SurveyEntry/Fetch', body, { headers: headers });
  }

  FetchCustomersbySurveyNo(customersurveyentry: Surveyentry) {

    let body = customersurveyentry;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SurveyEntry/FetchListbySurveyNo', body, { headers: headers });
  }

  
  // FetchSurveyEntryDetails(surveyNo: number){
  //   this.selectedSurveyentry.SurveyNo = surveyNo;   
  //   let body =  this.selectedSurveyentry.SurveyNo ;
  //   const headers = new HttpHeaders();
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   return this.httpClient.post<any>(this.getBaseUrl() + 'api/Surveyentry/FetchListbySurveyNo', body, { headers: headers });
  // }

  
  FetchStaffList(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Staff', body, { headers: headers });
  }

}
